import { useState, useEffect, useCallback } from 'react';

import { ChapterLocationService } from '../services/ChapterLocationService';

/**
 * Hook to fetch Chapter Location data
 * 
 * @param {string|number} level 
 * @param {string|number} chapter 
 * @returns {Object} { data, loading, error, refresh }
 */
export const useChapterLocation = (level, chapter) => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        if (!level || !chapter) return;

        try {
            setLoading(true);
            setError(null);
            const result = await ChapterLocationService.getChapterLocations(level, chapter);
            setData(result);
        } catch (err) {
            setError(err.message || 'Failed to load chapter locations');
            console.error(err);
        } finally {
            setLoading(false);
        }
    }, [level, chapter]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return {
        data,
        loading,
        error,
        refresh: fetchData
    };
};
